import { useCRUDList } from '@/shared/hooks/useCRUDList';
import { bankUserService } from '@/services/bankUser.service';
import type { BankUser } from '@/services/types/user.types';

const bankUserServiceAdapter = {
  getAll: () => bankUserService.getAllBankUsers(),
  delete: (id: string) => bankUserService.deleteBankUser(id),
};

export function useBankUserList() {
  const {
    items: bankUsers,
    loading,
    handleNew,
    handleEdit,
    handleDelete,
  } = useCRUDList<BankUser>({
    service: bankUserServiceAdapter,
    entityName: 'usuário do banco',
    routes: {
      new: '/bank-register',
      edit: (id) => `/bank-edit/${id}`,
    },
    messages: {
      loadError: 'Erro ao carregar usuários do banco',
      deleteSuccess: 'Usuário excluído com sucesso!',
      deleteError: 'Erro ao excluir usuário',
    },
  });

  const columns = [
    { key: 'name', title: 'Nome', dataIndex: 'name' },
    { key: 'email', title: 'Email', dataIndex: 'email' },
    { key: 'phoneNumber', title: 'Telefone', dataIndex: 'phoneNumber' },
  ];

  return {
    bankUsers,
    loading,
    columns,
    handleNew,
    handleEdit,
    handleDelete,
  };
}
